import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../config';

export interface SettingsAuditPerson {
  id: number;
  name: string | null;
}

export interface SettingsAuditSettingRow {
  key: string;
  label: string;
  value: string;
  old_value?: string | null;
  new_value?: string | null;
}

export interface SettingsAuditEvent {
  id: number;
  action: string;
  action_type: string;
  scope?: string;
  actor: SettingsAuditPerson;
  employee_ids: number[];
  employees: SettingsAuditPerson[];
  employee_count: number;
  team_id: number;
  settings: Record<string, string | boolean | number | null>;
  settings_summary: SettingsAuditSettingRow[];
  updated_at: string | null;
  updated_at_utc: string | null;
}

export interface SettingsAuditListQuery {
  timezone?: string;
  start_date?: string;
  end_date?: string;
  employee_user_id?: number;
  actor_user_id?: number;
  page?: number;
  per_page?: number;
}

export interface SettingsAuditListResponse {
  success?: boolean;
  events?: SettingsAuditEvent[];
  total?: number;
  page?: number;
  per_page?: number;
  timezone?: string;
  start_date?: string;
  end_date?: string;
  error?: string;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class SettingsAuditService {
  private readonly apiUrl = `${config.baseUrl}supersee/v1/settings-audit`;

  constructor(private http: HttpClient) {}

  list(query: SettingsAuditListQuery = {}): Observable<SettingsAuditListResponse> {
    let params = new HttpParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params = params.set(key, String(value));
    });
    return this.http.get<SettingsAuditListResponse>(this.apiUrl, { params });
  }
}
